<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Patient's Bookings",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Patient's Bookings",
            items: [
               {
                  text: "Patients",
                  href: "/patients",
               },  
               {
                  text: "Patient's Bookings",
                  active: true,
               },                   
            ],

            bookings: [],            
            booking_status: '',

            from: null,
            to: null,
            total: null,
            pagination: {},
            
            keyword: "",
            showsearch: false,
            listing_length: 10,
            token: "",
            errors: {},          
            active_page_url: null,
         };
      },
      mounted() {
    
      },

      created() {
         this.fetchBookings();
      },

      methods: {
         fetchBookings(page_url = null) {

            this.getToken();
            let url = "api/admin/patient/bookings?keyword=" + this.keyword + "&limit=" + this.listing_length + "&status=" + this.booking_status + "&patient_id="  + this.$route.params.id;

            page_url = page_url || url;

            if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
            }    

            this.active_page_url = page_url;
            this.loading = true;
            
            this.$axios
               .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.bookings = responseData.bookings.data;
                  
                  this.pagination = responseData.bookings.links;
                  this.from = responseData.bookings.from;
                  this.to = responseData.bookings.to;
                  this.total = responseData.bookings.total;
               
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         }, 

         getToken() {
            if (localStorage.getItem('medicino_admin')) {
               var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
               if(medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        <router-link :to="{ name: 'patients' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length" @change="fetchBookings()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchBookings()"/>
                           </label>
                        </div>                     
                        <div class="listing-filter me-2">
                           <label>
                              <select class="form-control" v-model="booking_status" @change="fetchBookings()">   
                                 <option value="">All</option>
                                 <option value="1">Upcoming bookings</option>
                                 <option value="2">Completed bookings</option>
                                 <option value="3">Cancelled bookings</option>
                                 <option value="4">Missed bookings</option>
                              </select>
                           </label>
                        </div>   
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                           <tr>
                              <th width="15%">Doctor</th>   
                              <th width="5%">Token</th>
                              <th width="20%">Booking Date & Slot</th>
                              <th width="10%">Type</th>
                              <th width="15%">Created on</th>
                              <th width="10%">Options</th>
                           </tr>
                        </thead>
                        <tbody v-if="Boolean(bookings.length)">
                           <tr v-for="(booking) in bookings" :key="booking.id">
                              <td><span v-if="booking.prefix == 1">Dr. </span><span v-else-if="booking.prefix == 2">Mr. </span><span v-else-if="booking.prefix == 3">Ms. </span> {{booking.doctor_name}}</td>
                              <td>{{booking.token}}</td>                 
                              <td>{{booking.booking_date | formatDate }}<br>{{booking.consultation_start | formatTime}} - {{booking.consultation_end | formatTime}} <span v-if="booking.clinic_id"><br>{{booking.clinic_name}}</span>  </td>
                              <td>
                                 <span v-if="booking.consultation_type==1">Video Consultation</span>  
                                 <span v-if="booking.consultation_type==2">Home Consultation</span>   
                                 <span v-if="booking.consultation_type==3">Clinic Consultation</span>  
                              </td>
                              <td>{{booking.created_at | formatDateTime}}</td>
                             
                              <td>
                                 <router-link :to="{ name: 'consultations.details', params: {id: booking.id} }" class="btn btn-primary me-2 mb-2 btn-sm">Details</router-link>
                              </td>
                           </tr>
                 
                        </tbody>
                        <tbody v-else>
                           <tr>
                              <td colspan="6" class="text-center">No bookings found</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts ---> 
                  <caption v-if="Boolean(bookings.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchBookings(page.url + '&limit='+ listing_length + '&keyword=' + keyword + '&status=' + booking_status  + '&patient_id=' + $route.params.id)">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->   

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
